import React from "react";
import { CommonModal } from "../../AbstractElements";

const ConfirmationModal = ({ isOpen, toggler, onConfirm, title, message, isLoading }) => {
  return (
    <CommonModal isOpen={isOpen} toggler={toggler} title={title} size="md">
      <div className="text-center p-4">
        <p className="mb-4">{message}</p>
        <div className="d-flex justify-content-center gap-2">
          <button className="btn btn-outline-secondary" onClick={toggler} disabled={isLoading}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={onConfirm}
            style={{ backgroundColor: "#41CC7D", borderColor: "#41CC7D" }}
            disabled={isLoading}
          >
            {isLoading ? "Working..." : "Confirm"}
          </button>
        </div>
      </div>
    </CommonModal>
  );
};

export default ConfirmationModal;
